import { ValidationErrorData } from '../typings/common';
import { PricePackagesClientsModalState } from '../typings/pricePackages';
import { TargetingTagValue } from '../typings/tagCloudTargeting';

export const SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA = 'SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA';
export type SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA = typeof SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA;

export interface SetPricePackagesClientsModalDataAction {
    type: SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA;
    modalData: PricePackagesClientsModalState;
}

export function setPricePackagesClientsModalDataAction(
    modalData: PricePackagesClientsModalState
): SetPricePackagesClientsModalDataAction {
    return {
        type: SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA,
        modalData
    };
}

export const SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR = 'SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR';
export type SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR = typeof SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR;

export interface ShowPricePackagesClientsModalError {
    type: SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR;
    errors: ValidationErrorData[];
}

export function showPricePackagesClientsModalError(errors: ValidationErrorData[]): ShowPricePackagesClientsModalError {
    return {
        type: SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR,
        errors
    };
}

export const CLOSE_PRICE_PACKAGES_CLIENTS_MODAL = 'CLOSE_PRICE_PACKAGES_CLIENTS_MODAL';
export type CLOSE_PRICE_PACKAGES_CLIENTS_MODAL = typeof CLOSE_PRICE_PACKAGES_CLIENTS_MODAL;

export interface ClosePricePackagesClientsModalAction {
    type: CLOSE_PRICE_PACKAGES_CLIENTS_MODAL;
}

export function closePricePackagesClientsModal(): ClosePricePackagesClientsModalAction {
    return {
        type: CLOSE_PRICE_PACKAGES_CLIENTS_MODAL
    };
}
export const OPEN_PRICE_PACKAGES_CLIENTS_MODAL = 'OPEN_PRICE_PACKAGES_CLIENTS_MODAL';
export type OPEN_PRICE_PACKAGES_CLIENTS_MODAL = typeof OPEN_PRICE_PACKAGES_CLIENTS_MODAL;

export interface OpenPricePackagesClientsModal {
    type: OPEN_PRICE_PACKAGES_CLIENTS_MODAL;
    id: number;
}

export function openPricePackagesClientsModal(id: number): OpenPricePackagesClientsModal {
    return {
        type: OPEN_PRICE_PACKAGES_CLIENTS_MODAL,
        id
    };
}

export const ADD_PRICE_PACKAGES_CLIENTS_MODAL = 'ADD_PRICE_PACKAGES_CLIENTS_MODAL';
export type ADD_PRICE_PACKAGES_CLIENTS_MODAL = typeof ADD_PRICE_PACKAGES_CLIENTS_MODAL;

export interface AddPricePackagesClientsModal {
    type: ADD_PRICE_PACKAGES_CLIENTS_MODAL;
    tags: TargetingTagValue[];
}

export function addPricePackagesClientsModal(tags: TargetingTagValue[]): AddPricePackagesClientsModal {
    return {
        type: ADD_PRICE_PACKAGES_CLIENTS_MODAL,
        tags
    };
}

export const DELETE_PRICE_PACKAGES_CLIENTS_MODAL = 'DELETE_PRICE_PACKAGES_CLIENTS_MODAL';
export type DELETE_PRICE_PACKAGES_CLIENTS_MODAL = typeof DELETE_PRICE_PACKAGES_CLIENTS_MODAL;

export interface DeletePricePackagesClientsModal {
    type: DELETE_PRICE_PACKAGES_CLIENTS_MODAL;
    tag: TargetingTagValue;
}

export const deletePricePackagesClientsModal = (tag: TargetingTagValue): DeletePricePackagesClientsModal => {
    return {
        type: DELETE_PRICE_PACKAGES_CLIENTS_MODAL,
        tag
    };
};

export const SAVE_PRICE_PACKAGES_CLIENTS_MODAL = 'SAVE_PRICE_PACKAGES_CLIENTS_MODAL';
export type SAVE_PRICE_PACKAGES_CLIENTS_MODAL = typeof SAVE_PRICE_PACKAGES_CLIENTS_MODAL;

export interface SavePricePackagesClientsModal {
    type: SAVE_PRICE_PACKAGES_CLIENTS_MODAL;
}

export const savePricePackagesClientsModal = (): SavePricePackagesClientsModal => {
    return {
        type: SAVE_PRICE_PACKAGES_CLIENTS_MODAL
    };
};

export type PricePackagesClientsModalAction =
    | AddPricePackagesClientsModal
    | SavePricePackagesClientsModal
    | ShowPricePackagesClientsModalError
    | DeletePricePackagesClientsModal
    | ClosePricePackagesClientsModalAction
    | SetPricePackagesClientsModalDataAction
    | OpenPricePackagesClientsModal;
